export const getAllCurrenciesEndpoint = 'currencies';
